document.addEventListener('DOMContentLoaded', () => {

    // Function to append and style the triangle arrow
    const appendTriangleArrow = (containerDiv) => {
        // Ensure each container has its own triangle
        let triangleDiv = containerDiv.querySelector('.triangle-arrow');
        if (!triangleDiv) {
            triangleDiv = document.createElement('div');
            triangleDiv.className = 'triangle-arrow';

            containerDiv.appendChild(triangleDiv);
            
        }

        const containerBackgroundColor = containerDiv.closest('.vayu-pin-spot-wrapper7').getAttribute('data-arrow') || '#444942';

        // Set styles for the triangle arrow
        triangleDiv.style.cssText = `
            position: absolute;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid ${containerBackgroundColor};
        `;
    };

    // Get all `.th-root-block-container` elements and process them
    const containerDivs = document.querySelectorAll('.vayu-pin-first-wrap');
    containerDivs.forEach((containerDiv) => appendTriangleArrow(containerDiv));

    
    //********************************Onclick Functionality************************************ */
     // Select all elements with class 'vayu-pin-spot-wrapper7' that also have 'tooltip-onClick'
     const tooltipOnClickElements = document.querySelectorAll('.vayu-pin-spot-wrapper7.tooltip-onClick');

     tooltipOnClickElements.forEach((tooltipElement) => {
         // Add click event listener to each matching element
         tooltipElement.addEventListener('click', (event) => {
             // Find the child element with the class 'vayu-pin-first-wrap'
             const firstWrap = tooltipElement.querySelector('.vayu-pin-first-wrap');
 
             if (firstWrap) {
                 // Toggle visibility using a class or inline style
                 firstWrap.classList.toggle('visible'); // Assumes CSS handles .visible
             }
         });
     });

});
